"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IExternalComponetConnectionSchema = void 0;
const zod_1 = require("zod");
const IModeCondition_1 = require("../DesignModels/IModeCondition");
const IExternalComponent_1 = require("./IExternalComponent");
exports.IExternalComponetConnectionSchema = zod_1.z.object({
    name: zod_1.z.string(),
    modelSignalId: zod_1.z.string().optional(),
    netConditions: zod_1.z.lazy(() => IModeCondition_1.IModeConditionSchema.array().optional()),
    components: zod_1.z
        .lazy(() => IExternalComponent_1.IExternalComponentSchema)
        .array()
        .optional(),
});
//# sourceMappingURL=IExternalComponetConnection.js.map